import { EProxyPayType, IPageParam } from '@core/main/types/common';

/**
 * 更换代理商状态
 */
export enum EChangeAgentStatus {
  /** 通过 */
  SUCCESS = 1,
  /** 失败 */
  FAIL = 0,
}

export const changeAgentStatusLabel = {
  [EChangeAgentStatus.SUCCESS]: '成功',
  [EChangeAgentStatus.FAIL]: '失败',
};

export const changeAgentStatusStyle = {
  [EChangeAgentStatus.SUCCESS]: 'success',
  [EChangeAgentStatus.FAIL]: 'danger',
};

/**
 * 更换代理商查询参数
 */
export interface IChangeAgentParam extends IPageParam {
  /** 申请时间开始 */
  applyTimeStart?: string;
  /** 申请时间结束 */
  applyTimeEnd?: string;
  /** 代理商名称 */
  agentName?: string;
  /** 企业统一社会信用代码 */
  creditCode?: string;
  /** 新代理商名称 */
  newParentAgentName?: string;
  /** 新代理商员工 */
  newAgentUserName?: string;
  /** 状态 */
  status?: EChangeAgentStatus;
  /** 操作人 */
  creatorId?: string;
  /** 企业名称 */
  companyName?: string;
  /** 原代理商名称 */
  oldAgentName?: string;
  /** 新代理商名称 */
  newAgentName?: string;
  /** 新代理商员工 */
  businessUserName?: string;
}

/**
 * 更换代理商记录
 */
export interface IChangeAgentRecord {
  /** 申请时间 */
  applyTime: string;
  /** 企业名称 */
  companyName: string;
  /** 统一社会信用代码 */
  creditCode: string;
  /** 更换代理商名称 */
  agentName: string;
  /** 原代理商 */
  oldAgentName: string;
  /** 新代理商 */
  newAgentName: string;
  /** 新代理商-员工 */
  businessUserName: string;
  /** 状态 */
  status: EChangeAgentStatus;
  /** 操作人 */
  operatorName: string;
  /** 操作人 */
  creator: string;
  /** 原因 */
  reason: string;
  /** 记录ID */
  id: number;
  /** 企业ID */
  companyId: number;
}

/**
 * 企业变更代理商-校验
 */
export interface IChangeAgentCheckItem {
  /** 检测项 */
  title?: number;
  /** 检测内容 */
  content?: number;
  /** 检测结果（0不满足 1满足） */
  result?: EChangeAgentCheckResult;
  /** 业务类型（0众包 1撮合 2公共） */
  flewWorkType?: EChangeAgentCheckType;
  /** 不满足内容 */
  failContent?: string;
}

/**
 * 检测结果（0不满足 1满足）
 */
export enum EChangeAgentCheckResult {
  /** 不满足 */
  FAIL = 0,
  /** 满足 */
  SUCCESS = 1,
}

export const changeAgentCheckResultLabel = {
  [EChangeAgentCheckResult.FAIL]: '不满足',
  [EChangeAgentCheckResult.SUCCESS]: '满足',
};

export const changeAgentCheckResultStyle = {
  [EChangeAgentCheckResult.FAIL]: 'danger',
  [EChangeAgentCheckResult.SUCCESS]: 'success',
};

/** 
 * 业务类型（0众包 1撮合 2公共）
 */
export enum EChangeAgentCheckType {
  /** 众包 */
  ZHONGBAO = 0,
  /** 撮合 */
  CUOHE = 1,
  /** 公共 */
  GONGGONG = 2,
}

export const changeAgentCheckTypeLabel = {
  [EChangeAgentCheckType.ZHONGBAO]: '众包检测',
  [EChangeAgentCheckType.CUOHE]: '撮合检测',
  [EChangeAgentCheckType.GONGGONG]: '公共检测',
};

export interface IChangeAgentCheckParam {
  /** 企业ID */
  companyId?: number;
  /** 代理商ID */
  agentId?: number;
  /** 旧代理商ID */
  oldAgentId?: number;
  /** 新代理商ID */
  newAgentId?: number;
  /** 要更换到的上级代理商ID */
  newParentAgentId?: number;
  /** 新代理商销售ID */
  businessUserId?: number;
  /** 原因 */
  reason?: string;
}

/**
 * 升级特代 - 代理商配置的产品列表
 */
export interface IUpdateAgentConfigItem {
  /** 产品ID */
  productId?: number;
  /** 需增加服务主体 */
  serverName?: number;
  /** 业务类型 */
  productType?: 0 | 1;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 授权特代费率 */
  agentAuthRate?: string;
  /** 成本费率 */
  costRate?: string;
  /** 平台盈利费率 */
  platformProfitRate?: string;
  /** 费率配置建议 */
  rateSuggestion?: string;
  /** 授权特代费率配置 */
  authRateConfig?: IUpdateAgentConfigRate;
  /** 成本费率配置 */
  costRateConfig?: IUpdateAgentConfigRate;
  /** 平台盈利费率配置 */
  profitRateConfig?: IUpdateAgentConfigRate;
  /** 企业 - 全额征税 */
  companyFullTax?: boolean;
  /** 企业 - 差额征税 */
  companyDiffTax?: boolean;
  /** 特代 - 全额征税 */
  agentFullTax?: boolean;
  /** 特代 - 差额征税 */
  agentDiffTax?: boolean;
  /** 企业已选支付通道 集合(字符串) */
  companyPayChannel?: string[];
  /** 特代已选支付通道 集合(字符串) */
  agentPayChannel?: string[];
  /** 撮合 - 普票 */
  normalTicket?: boolean;
  /** 撮合 - 专票 */
  advancedTicket?: boolean;
  /** 是否配置 */
  isConfig?: boolean;
}

/**
 * 授权特代费率配置
 */
export interface IUpdateAgentConfigRate {
  /** 授权特代费率 */
  rate?: number;
  /** 授权特代费率差值 */
  diffRate?: number;
}

/**
 * 升级特代 - 确认变更
 */
export interface IUpdateAgentConfirm {
  /** 产品ID */
  productId: number;
  /** 支付通道 */
  payChannel: string[];
  /** 授权特代费率 */
  authRate: number;
  /** 企业 - 全额征税 */
  agentFullTax: boolean;
  /** 企业 - 差额征税 */
  agentDiffTax: boolean;
  /** 业务类型 */
  productType: 0 | 1;
}

/**
 * 升级特代 - 确认变更
 */
export interface IUpdateAgentConfigConfirm {
  /** 代理商ID */
  agentId: number;
  /** 原因 */
  reason: string;
  /** 支付通道 */
  authList: IUpdateAgentConfirm[];
  /** 新代理商销售ID */
  businessUserId?: number;
}
